import React, { useContext, useState } from 'react';
import './ShoppingItem.css';
import Image from '../shared/Image';
import preview from './../../public/image/preview.png'
import config from './../../config.json';
import MainContext from '../../context/mainContext';
import { priceFormat } from '../../util/showPriceFormat';
import { charsNormalize } from '../../util/charactorsNormalize';
import toast from 'react-hot-toast';
import { cleanFloat } from '../../util/cleanFloat';

const ShoppingItem = ({ _id, image, name, price, defaultCount, inventory, unit, preNameUnit, incrementalStep }) => {

    const [editableMode, setEditableMode] = useState(false);
    const [count, setCount] = useState(defaultCount)
    const context = useContext(MainContext);

    const countHandler = (eValue, operator) => {
        let data = {
            _id,
            name,
            price,
            image,
            count,
            inventory,
            unit,
            incrementalStep
        }
        switch (operator) {
            case '+':
                if (context.appSetting && !context.appSetting.negetiveInventory && inventory < (Number(count) || 0) + incrementalStep) {

                    return toast.error('موجودی محصول به اتمام رسیده است')
                }
                context.addToShoppingCart({ ...data, count: (Number(count) || 0) < 9999 ? cleanFloat((Number(count) || 0) + incrementalStep) : Number(count) })
                setCount(prev => String(cleanFloat(Number(prev || 0) + incrementalStep)));
                break;
            case '-':
                context.removeFromShoppingCart({ ...data, count: cleanFloat(Number(count) - incrementalStep) })
                setCount(prev => String(cleanFloat(Number(prev) - incrementalStep)));
                break;
            case 'custom':
                if (eValue) {
                    if (context.appSetting && !context.appSetting.negetiveInventory && inventory < Number(eValue)) {
                        return toast.error('موجودی محصول به اتمام رسیده است')
                    }
                    context.addToShoppingCart({ ...data, count: Number(eValue) })
                    setCount(String(eValue));
                }
                else if (eValue === '') {
                    setCount(eValue)
                }
                break;
            default:
                break;
        }
    }

    const regix = /^-?\d*\.?\d*$/;

    const handleCloseEditMode = () => {
        if (count === '') {
            setCount(defaultCount);
        }
        setEditableMode(false);
    }


    return (
        <div className='shopping-item' onClick={handleCloseEditMode}>
            <Image
                src={image ? `${config.api_address}/upload/${image}` : preview}
                width={60}
                height={60}
                borderRadius={'0 10px 10px 0'}
                style={{ objectFit: 'cover', opacity: image ? '1' : '.5' }}
            />
            <div className='middle col'>
                {name}
            </div>
            <div className="end-section" onClick={(e) => e.stopPropagation()}>
                {
                    editableMode ?
                        <React.Fragment>
                            <div className="count-selection">
                                <button onClick={e => countHandler(e, '+')}
                                    className='btn btn-success btn-sm'
                                ><i className="fa fa-plus"></i></button>
                                <div className='mx-1'>
                                    <input
                                        type='tel'
                                        className='form-control ltr text-center'
                                        disabled={context.appSetting && !context.appSetting.customCountInput}
                                        style={{ width: '57px', fontSize: '.8rem' }}
                                        value={count}
                                        onChange={(e) => {
                                            let normalized = '';
                                            if (e.target.value) {
                                                normalized = charsNormalize(e.target.value);
                                            }
                                            if (normalized === '' || (regix.test(normalized) && Number(normalized) > 0 && Number(normalized) <= 9999)) {
                                                countHandler(normalized ? normalized : '', 'custom')
                                            }
                                        }}
                                        onBlur={handleCloseEditMode}
                                    />
                                </div>
                                <button onClick={e => countHandler(e, '-')}
                                    className='btn btn-danger btn-sm'
                                ><i className={`${(count <= incrementalStep) ? "fa fa-trash" : "fa fa-minus"}`}></i></button>
                            </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <div className="price-item text-success">فی جزء : {priceFormat(price)} <span style={{ marginRight: '0px' }}>{config.currencyType}</span></div>
                            <div className='d-flex'>
                                <div className="price-item text-primary">
                                    {preNameUnit}: {(unit === 'کیلو گرم' && count < 1) ? count * 1000 : count} {(unit === 'کیلو گرم' && count < 1) ? 'گرم' : unit}
                                </div>
                                <button className='btn btn-sm btn-warning p-0 ms-auto' onClick={() => setEditableMode(prev => !prev)}
                                    style={{ height: '20px', width: '20px' }}><i className='fa fa-pencil'></i>
                                </button>
                            </div>
                        </React.Fragment>
                }
                {
                    editableMode ?
                        <div className="price-item text-primary d-flex justify-content-center">
                            {preNameUnit}: {(unit === 'کیلو گرم' && count < 1) ? count * 1000 : count} {(unit === 'کیلو گرم' && count < 1) ? 'گرم' : unit}
                        </div>
                        :
                        <div className="price-item">فی کل : {priceFormat(cleanFloat(price * count))} <span style={{ marginRight: '0px' }}>{config.currencyType}</span></div>

                }
            </div>
        </div>
    );
}

export default ShoppingItem;